export enum TwoFactorAuthStatus {
  'not_found',
  'no_response',
  'invalid',
  'required',
  'locked',
  'unsupported',
  'success',
  'expired',
  'open',
  'pending',
  'verified',
}
